/**
 * Data-driven step progress (lifecycle automation, SSWS fetch phases, etc.).
 */
export default function AutomationProgressBar({ steps = [] }) {
  if (!Array.isArray(steps) || !steps.length) return null;

  return (
    <div className="mt-3 space-y-2">
      <div className="flex h-2 overflow-hidden rounded-full bg-white/[0.08]">
        {steps.map((s, i) => {
          const st = s.state === "done" ? "done" : s.state === "active" ? "active" : "pending";
          const w = `${100 / steps.length}%`;
          const bg =
            st === "done"
              ? "bg-emerald-400/90"
              : st === "active"
                ? "bg-[rgb(var(--idaxis-accent-primary-rgb)/0.9)] animate-pulse"
                : "bg-white/10";
          return (
            <div
              key={s.id || i}
              className={`h-full transition-all ${bg}`}
              style={{ width: w }}
              title={s.label}
            />
          );
        })}
      </div>
      <ul className="space-y-1 text-[11px] text-slate-400">
        {steps.map((s, i) => (
          <li
            key={s.id || i}
            className={
              s.state === "done"
                ? "text-emerald-300/90"
                : s.state === "active"
                  ? "text-[rgb(var(--idaxis-accent-primary-rgb)/0.9)]"
                  : "text-slate-500"
            }
          >
            <span className="font-medium text-slate-500">{i + 1}.</span> {s.label}
            {s.state === "active" ? " …" : s.state === "done" ? " ✓" : ""}
          </li>
        ))}
      </ul>
    </div>
  );
}
